import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/exhibition/exhibitors')({
  staticData: { crumb: { parents: [{ label: 'Exhibition' }], label: 'Exhibitors' } },
})
